// extracted by mini-css-extract-plugin
export default {"section":"about_common_section__HvdCT","eyebrow":"about_common_eyebrow__AoopI","header":"about_common_header__p6QKi"};